import { ChangeEvent, ReactNode } from 'react';
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form';
import MessageError from '@components/form/MessageError';

export type TextInputType = {
	label?: ReactNode;
	labelClass?: string;
	error?: string | null | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined;
	className?: string;
};

export const messageError = (
	error: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined
): string => {
	if (!error) {
		return '';
	}

	if (typeof error === 'string') {
		return error;
	}

	if (error?.message && typeof error.message === 'string') {
		return error.message;
	}

	return '';
};

const TextInput = ({
	label,
	labelClass = '',
	error,
	className = '',
	children,
}: TextInputType & {
	children: ReactNode;
}) => {
	return (
		<div className={`input-field ${className}`}>
			{label ? <label className={`text-sm font-semibold ml-1 mb-1 ${labelClass}`}>{label}</label> : null}
			{children}
			{error ? <MessageError error={messageError(error)} /> : null}
		</div>
	);
};

export const TextInputDefault = ({
	label,
	labelClass = '',
	error,
	className = '',
	value,
	type = "text",
	name,
	placeholder,
	onChange,
	disabled,
}: {
	label: string;
	labelClass?: string;
	error: string | null | undefined;
	className?: string;
	value: string | number | undefined;
	type?: "text" | "number" | "email" | "password";
	name: string;
	placeholder: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	disabled: boolean;
}) => {
	return (
		<div className={`input-field ${className}`}>
			{label ? <label className={`text-sm font-semibold ml-1 mb-1 ${labelClass}`}>{label}</label> : null}
			<input
				name={name}
				value={value}
				type={type}
				style={{
					borderWidth: error ? "1px" : "1px",
					padding: "18px",
					borderRadius: "10px",
					height: 50,
				}}
				disabled={disabled}
				placeholder={placeholder}
				className={`text-black ${error ? "border-red-500" : "border-gray-300"}`}
				onChange={onChange}
			/>
			{error ? <MessageError error={messageError(error)} /> : null}
		</div>
	)
};

export default TextInput;
